import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1acee18e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wallet-list" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "wallet-logo" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "wallet-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.walletList, (wallet) => {
      return (_openBlock(), _createElementBlock("li", {
        key: wallet.type,
        onClick: ($event: any) => (_ctx.toConnect(wallet.type))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: require(`./images/${wallet.logo}`),
            alt: ""
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h4", null, _toDisplayString(wallet.type), 1)
        ])
      ], 8, _hoisted_2))
    }), 128))
  ]))
}